export const filters = {
  application: {
    "order[]": {
      name: "ordenar-por",
      values: {},
    },
    "filters[]": {
      name: "filtros[]",
      values: {},
    },
    "orFilters[]": {
      name: "ouFiltros[]",
      values: {},
    },
  },
  api: {
    "ordenar-por": {
      name: "order[]",
      values: {
        "novos-especialistas": "created_at,DESC",
        "melhores-precos": "cheapest",
        "melhores-avaliados": "rating,DESC",
        "mais-consultados": "number_of_transactions,DESC",
      },
    },
    "filtros[]": {
      name: "filters[]",
      values: {
        "servico=chat":
          "filters[]=sellers_services.service,=,chat-consultation",
        "servico=telefone":
          "filters[]=sellers_services.service,=,phone-consultation",
        "especialidade=": "filters[]=therapies.slug,=,",
        "termo=": "filters[]=search,ilike,",
        "tags=": "filters[]=tags,contains,",
      },
    },
    "ouFiltros[]": {
      name: "orFilters[]",
      values: {
        "servico=email":
          "orFilters[]=sellers_services.service,=,short-email-questions&orFilters[]=sellers_services.service,=,long-email-questions",
      },
    },
  },
};
